<template>
  <component :is="tag">{{text}}</component>
</template>

<script setup lang="ts">
const props = defineProps(['tag', 'text']);

</script>